module.exports = __webpack_public_path__ + "img/partical-capacitor-lv2.1b8dbb11.png";